import { paletteColorsV3 } from "./vivicaUiKitColors.js";
const colorTokens = {
  /** @deprecated */
  text: {
    primary: paletteColorsV3.grey[800],
    disabled: paletteColorsV3.grey[500],
    secondary: paletteColorsV3.grey[500]
  },
  // actual tokenized colors
  content: {
    accent: {
      primary: paletteColorsV3.primary[900],
      secondary: paletteColorsV3.secondary[900]
    },
    invert: paletteColorsV3.white,
    base: {
      default: paletteColorsV3.grey[800],
      disabled: paletteColorsV3.grey[400]
    },
    additional: {
      default: paletteColorsV3.grey[500],
      disabled: paletteColorsV3.grey[400]
    },
    alert: {
      error: paletteColorsV3.radicalRed[900],
      attention: paletteColorsV3.sunnyYellow[800],
      success: paletteColorsV3.tiffanyBlue[900],
      info: paletteColorsV3.blueGreen[900]
    }
  },
  bg: {
    accent: {
      primary: paletteColorsV3.primary[900],
      secondary: paletteColorsV3.secondary[900],
      tertiary: paletteColorsV3.grey[400],
      quaternary: paletteColorsV3.grey[800]
    },
    invert: paletteColorsV3.white,
    base: {
      elevation1: paletteColorsV3.secondary[200],
      elevation2: paletteColorsV3.secondary[300],
      elevation3: paletteColorsV3.secondary[400]
    },
    additional: {
      elevation1: paletteColorsV3.grey[100],
      elevation2: paletteColorsV3.grey[200]
    },
    disabled: paletteColorsV3.grey[200]
  },
  border: {
    base: {
      elevation1: paletteColorsV3.secondary[300],
      elevation2: paletteColorsV3.secondary[400],
      elevation3: paletteColorsV3.secondary[500]
    },
    additional: {
      elevation1: paletteColorsV3.grey[300],
      elevation2: paletteColorsV3.grey[400],
      elevation3: paletteColorsV3.grey[500],
      elevation4: paletteColorsV3.grey[600]
    },
    critical: paletteColorsV3.primary[300],
    accent: {
      primary: paletteColorsV3.primary[900],
      secondary: paletteColorsV3.secondary[900],
      tertiary: paletteColorsV3.grey[400],
      quaternary: paletteColorsV3.grey[800]
    },
    invert: paletteColorsV3.white,
    disabled: paletteColorsV3.grey[300]
  },
  // Component tokens
  btn: {
    solid: {
      content: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.white,
        active: paletteColorsV3.white,
        disabled: paletteColorsV3.grey[400]
      },
      bg: {
        disabled: paletteColorsV3.grey[200]
      }
    },
    transparent: {
      disabled: paletteColorsV3.grey[400]
    },
    primary: {
      solid: {
        bg: {
          default: paletteColorsV3.primary[900],
          hover: paletteColorsV3.primary[800],
          active: paletteColorsV3.primary[1e3]
        }
      },
      transparent: {
        default: paletteColorsV3.primary[900],
        hover: paletteColorsV3.primary[800],
        active: paletteColorsV3.primary[1e3]
      }
    },
    secondary: {
      solid: {
        bg: {
          default: paletteColorsV3.secondary[900],
          hover: paletteColorsV3.secondary[800],
          active: paletteColorsV3.secondary[1e3]
        }
      },
      transparent: {
        default: paletteColorsV3.secondary[900],
        hover: paletteColorsV3.secondary[800],
        active: paletteColorsV3.secondary[1e3]
      }
    },
    invert: {
      solid: {
        content: paletteColorsV3.grey[800],
        bg: {
          default: paletteColorsV3.white,
          hover: paletteColorsV3.grey[100],
          active: paletteColorsV3.grey[200]
        }
      },
      transparent: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.grey[100],
        active: paletteColorsV3.grey[200]
      }
    },
    tertiary: {
      transparent: {
        default: paletteColorsV3.grey[400],
        hover: paletteColorsV3.grey[500],
        active: paletteColorsV3.grey[600]
      }
    },
    quaternary: {
      transparent: {
        default: paletteColorsV3.grey[800],
        hover: paletteColorsV3.grey[700],
        active: paletteColorsV3.grey[900]
      }
    }
  },
  togglebtn: {
    rating: {
      selected: {
        default: paletteColorsV3.sunnyYellow[800],
        hover: paletteColorsV3.sunnyYellow[1e3]
      }
    },
    link: {
      selected: {
        default: paletteColorsV3.primary[900],
        hover: paletteColorsV3.primary[1e3]
      }
    },
    check: {
      selected: {
        default: paletteColorsV3.secondary[900],
        hover: paletteColorsV3.secondary[1e3]
      }
    },
    fav: {
      selected: {
        default: paletteColorsV3.grey[400],
        hover: paletteColorsV3.grey[500]
      }
    },
    unselected: {
      default: paletteColorsV3.grey[400],
      hover: paletteColorsV3.grey[500]
    }
  },
  field: {
    placeholder: paletteColorsV3.grey[500],
    inputuser: paletteColorsV3.grey[800],
    bg: paletteColorsV3.white,
    icon: paletteColorsV3.grey[400],
    regularbg: {
      border: {
        default: paletteColorsV3.grey[400],
        hover: paletteColorsV3.grey[500],
        active: paletteColorsV3.grey[600],
        error: paletteColorsV3.radicalRed[900],
        disabled: paletteColorsV3.grey[400]
      },
      bg: {
        disabled: paletteColorsV3.grey[200]
      },
      placeholder: {
        disabled: paletteColorsV3.grey[400]
      },
      inputuser: {
        disabled: paletteColorsV3.grey[500]
      }
    },
    bluebg: {
      border: {
        default: paletteColorsV3.secondary[500],
        hover: paletteColorsV3.secondary[700],
        active: paletteColorsV3.secondary[700],
        error: paletteColorsV3.radicalRed[900],
        disabled: paletteColorsV3.secondary[500]
      },
      bg: {
        disabled: paletteColorsV3.secondary[100]
      }
    },
    /** @deprecated */
    border: {
      default: paletteColorsV3.grey[400],
      hover: paletteColorsV3.grey[500],
      active: paletteColorsV3.grey[600],
      error: paletteColorsV3.radicalRed[900],
      disabled: paletteColorsV3.grey[400]
    },
    /** @deprecated */
    background: {
      default: paletteColorsV3.white,
      hover: paletteColorsV3.white,
      active: paletteColorsV3.white,
      error: paletteColorsV3.white,
      disabled: paletteColorsV3.grey[200]
    }
  },
  switch: {
    selected: {
      default: paletteColorsV3.secondary[900],
      hover: paletteColorsV3.secondary[800],
      active: paletteColorsV3.secondary[1e3],
      disabled: paletteColorsV3.grey[400]
    },
    unselected: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.secondary[200],
        active: paletteColorsV3.secondary[400],
        disabled: paletteColorsV3.grey[200],
        error: paletteColorsV3.white
      },
      border: {
        default: paletteColorsV3.secondary[900],
        hover: paletteColorsV3.secondary[800],
        active: paletteColorsV3.secondary[1e3],
        disabled: paletteColorsV3.grey[400],
        error: paletteColorsV3.radicalRed[900]
      }
    }
  },
  sidebartab: {
    closed: {
      bg: {
        default: paletteColorsV3.secondary[900],
        hover: paletteColorsV3.secondary[800],
        active: paletteColorsV3.secondary[1e3],
        disabled: paletteColorsV3.secondary[900]
      },
      content: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.white,
        active: paletteColorsV3.white,
        disabled: paletteColorsV3.secondary[700]
      }
    },
    opened: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.grey[200],
        active: paletteColorsV3.secondary[200],
        disabled: paletteColorsV3.white
      },
      content: {
        default: paletteColorsV3.grey[800],
        hover: paletteColorsV3.grey[800],
        active: paletteColorsV3.secondary[900],
        disabled: paletteColorsV3.grey[400]
      }
    }
  },
  table: {
    base: {
      default: paletteColorsV3.white,
      hover: paletteColorsV3.secondary[200],
      active: paletteColorsV3.secondary[300],
      selected: paletteColorsV3.grey[100],
      disabled: paletteColorsV3.grey[100]
    },
    border: paletteColorsV3.grey[300],
    critical: {
      default: paletteColorsV3.primary[200],
      hover: paletteColorsV3.primary[300],
      pressed: paletteColorsV3.primary[400]
    },
    additional: {
      default: paletteColorsV3.sunnyYellow[200],
      hover: paletteColorsV3.sunnyYellow[300],
      pressed: paletteColorsV3.sunnyYellow[400]
    },
    disabled: paletteColorsV3.grey[100]
  },
  ddrow: {
    bg: {
      default: paletteColorsV3.white,
      hover: paletteColorsV3.secondary[200],
      active: paletteColorsV3.secondary[300],
      selected: paletteColorsV3.grey[200],
      disabled: paletteColorsV3.grey[100]
    },
    content: {
      default: paletteColorsV3.grey[800],
      hover: paletteColorsV3.secondary[900],
      active: paletteColorsV3.secondary[900],
      selected: paletteColorsV3.grey[800],
      disabled: paletteColorsV3.grey[500]
    },
    iconright: {
      default: paletteColorsV3.grey[400],
      hover: paletteColorsV3.secondary[900],
      active: paletteColorsV3.secondary[900],
      selected: paletteColorsV3.grey[400],
      disabled: paletteColorsV3.grey[400]
    }
  },
  progbar: {
    previous: {
      default: paletteColorsV3.secondary[900],
      hover: paletteColorsV3.secondary[800],
      active: paletteColorsV3.secondary[1e3]
    },
    current: {
      default: paletteColorsV3.secondary[900],
      hover: paletteColorsV3.secondary[900],
      active: paletteColorsV3.secondary[900],
      text: paletteColorsV3.grey[800]
    },
    next: {
      default: paletteColorsV3.grey[400],
      hover: paletteColorsV3.grey[400],
      active: paletteColorsV3.grey[400],
      text: paletteColorsV3.grey[800]
    }
  },
  avatar: {
    bg: {
      default: paletteColorsV3.secondary[600],
      hover: paletteColorsV3.secondary[700],
      active: paletteColorsV3.secondary[900],
      disabled: paletteColorsV3.grey[300]
    },
    content: {
      default: paletteColorsV3.white,
      hover: paletteColorsV3.white,
      active: paletteColorsV3.white,
      disabled: paletteColorsV3.grey[500]
    }
  },
  toggle: {
    handle: {
      default: paletteColorsV3.white,
      hover: paletteColorsV3.white,
      active: paletteColorsV3.white,
      disabled: paletteColorsV3.grey[200]
    },
    selected: {
      track: {
        default: paletteColorsV3.secondary[900],
        hover: paletteColorsV3.secondary[1e3],
        active: paletteColorsV3.secondary[1e3],
        disabled: paletteColorsV3.grey[500]
      }
    },
    unselected: {
      track: {
        default: paletteColorsV3.grey[500],
        hover: paletteColorsV3.grey[700],
        active: paletteColorsV3.grey[700],
        disabled: paletteColorsV3.grey[400]
      }
    }
  },
  tag: {
    primary: {
      bg: {
        default: paletteColorsV3.secondary[200],
        disabled: paletteColorsV3.grey[200]
      },
      border: {
        default: paletteColorsV3.secondary[500],
        disabled: paletteColorsV3.grey[300]
      },
      content: {
        default: paletteColorsV3.secondary[900],
        disabled: paletteColorsV3.grey[400]
      }
    },
    secondary: {
      bg: {
        default: paletteColorsV3.grey[200],
        disabled: paletteColorsV3.grey[200]
      },
      border: {
        default: paletteColorsV3.grey[400],
        disabled: paletteColorsV3.grey[300]
      },
      content: {
        default: paletteColorsV3.grey[800],
        disabled: paletteColorsV3.grey[400]
      }
    }
  },
  status: {
    content: {
      error: paletteColorsV3.radicalRed[900],
      attention: paletteColorsV3.sunnyYellow[800],
      success: paletteColorsV3.tiffanyBlue[900],
      info: paletteColorsV3.blueGreen[900],
      accept: paletteColorsV3.ube[900],
      important: paletteColorsV3.gamboge[900],
      archive: paletteColorsV3.mountbattenPink[900],
      nul: paletteColorsV3.grey[800]
    },
    bg: {
      error: paletteColorsV3.radicalRed[200],
      attention: paletteColorsV3.sunnyYellow[200],
      success: paletteColorsV3.tiffanyBlue[200],
      info: paletteColorsV3.blueGreen[200],
      accept: paletteColorsV3.ube[200],
      important: paletteColorsV3.gamboge[200],
      archive: paletteColorsV3.mountbattenPink[200],
      nul: paletteColorsV3.grey[200]
    }
  },
  notification: {
    border: paletteColorsV3.secondary[300],
    base: {
      bg: {
        default: paletteColorsV3.white,
        read: paletteColorsV3.white,
        hover: paletteColorsV3.grey[100],
        active: paletteColorsV3.white
      },
      content: {
        default: paletteColorsV3.grey[800],
        read: paletteColorsV3.grey[700],
        hover: paletteColorsV3.grey[700],
        active: paletteColorsV3.grey[700]
      },
      indicator: paletteColorsV3.grey[200]
    },
    critical: {
      bg: {
        default: paletteColorsV3.radicalRed[200],
        read: paletteColorsV3.radicalRed[200],
        hover: paletteColorsV3.radicalRed[300],
        active: paletteColorsV3.radicalRed[200]
      },
      content: {
        default: paletteColorsV3.grey[800],
        read: paletteColorsV3.grey[700],
        hover: paletteColorsV3.grey[700],
        active: paletteColorsV3.grey[700]
      },
      indicator: paletteColorsV3.primary[600]
    }
  },
  badge: {
    primary: {
      text: {
        default: paletteColorsV3.white
      },
      bg: {
        default: paletteColorsV3.radicalRed[900]
      }
    },
    secondary: {
      text: {
        default: paletteColorsV3.white
      },
      bg: {
        default: paletteColorsV3.secondary[900]
      }
    },
    bg: {
      disabled: paletteColorsV3.grey[300]
    },
    text: {
      disabled: paletteColorsV3.grey[500]
    },
    invert: {
      text: {
        default: paletteColorsV3.grey[800]
      },
      bg: {
        default: paletteColorsV3.white
      }
    }
  },
  tab: {
    transparent: {
      selected: {
        default: paletteColorsV3.secondary[900],
        hover: paletteColorsV3.secondary[800],
        disabled: paletteColorsV3.grey[500]
      },
      unselected: {
        default: paletteColorsV3.grey[500],
        hover: paletteColorsV3.grey[700],
        disabled: paletteColorsV3.grey[400]
      }
    },
    solid: {
      selected: {
        bg: {
          default: paletteColorsV3.white,
          hover: paletteColorsV3.white,
          disabled: paletteColorsV3.grey[200]
        },
        border: {
          default: paletteColorsV3.secondary[300],
          hover: paletteColorsV3.secondary[300],
          disabled: paletteColorsV3.grey[300]
        },
        content: {
          default: paletteColorsV3.grey[800],
          hover: paletteColorsV3.secondary[900],
          disabled: paletteColorsV3.grey[400]
        }
      },
      unselected: {
        bg: {
          default: paletteColorsV3.secondary[300],
          hover: paletteColorsV3.secondary[400],
          disabled: paletteColorsV3.grey[300]
        },
        border: {
          default: paletteColorsV3.secondary[500],
          hover: paletteColorsV3.secondary[500],
          disabled: paletteColorsV3.grey[300]
        },
        content: {
          default: paletteColorsV3.secondary[900],
          hover: paletteColorsV3.secondary[900],
          disabled: paletteColorsV3.grey[400]
        }
      }
    }
  },
  breadcrumb: {
    default: paletteColorsV3.grey[800],
    hover: paletteColorsV3.grey[700],
    active: paletteColorsV3.grey[900],
    disabled: paletteColorsV3.grey[400]
  },
  pagination: {
    primary: {
      default: paletteColorsV3.white,
      hover: paletteColorsV3.primary[400],
      active: paletteColorsV3.radicalRed[800]
    },
    secondary: {
      default: paletteColorsV3.secondary[900],
      hover: paletteColorsV3.secondary[800],
      active: paletteColorsV3.secondary[1e3],
      disabled: paletteColorsV3.secondary[400]
    },
    tertiary: {
      default: paletteColorsV3.grey[400],
      hover: paletteColorsV3.grey[600],
      active: paletteColorsV3.grey[900]
    }
  },
  chip: {
    primary: {
      selected: {
        bg: {
          default: paletteColorsV3.secondary[200],
          hover: paletteColorsV3.secondary[300],
          active: paletteColorsV3.secondary[400],
          disabled: paletteColorsV3.grey[300]
        },
        content: {
          default: paletteColorsV3.secondary[900],
          hover: paletteColorsV3.secondary[900],
          active: paletteColorsV3.secondary[1e3],
          disabled: paletteColorsV3.secondary[500]
        }
      },
      unselected: {
        bg: {
          default: paletteColorsV3.grey[200],
          hover: paletteColorsV3.grey[300],
          active: paletteColorsV3.grey[300],
          disabled: paletteColorsV3.grey[200]
        },
        content: {
          default: paletteColorsV3.grey[500],
          hover: paletteColorsV3.grey[600],
          active: paletteColorsV3.grey[700],
          disabled: paletteColorsV3.grey[500]
        }
      }
    },
    secondary: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.white,
        active: paletteColorsV3.white,
        disabled: paletteColorsV3.grey[200]
      },
      selected: {
        content: {
          default: paletteColorsV3.secondary[900],
          hover: paletteColorsV3.secondary[800],
          active: paletteColorsV3.secondary[1e3],
          disabled: paletteColorsV3.secondary[500]
        }
      },
      unselected: {
        content: {
          default: paletteColorsV3.grey[500],
          hover: paletteColorsV3.grey[600],
          active: paletteColorsV3.grey[700],
          disabled: paletteColorsV3.grey[400]
        }
      }
    }
  },
  banner: {
    bg: {
      error: paletteColorsV3.radicalRed[200],
      attention: paletteColorsV3.sunnyYellow[200],
      success: paletteColorsV3.tiffanyBlue[200],
      info: paletteColorsV3.blueGreen[200]
    },
    border: {
      error: paletteColorsV3.radicalRed[400],
      attention: paletteColorsV3.sunnyYellow[400],
      success: paletteColorsV3.tiffanyBlue[400],
      info: paletteColorsV3.blueGreen[400]
    },
    icon: {
      error: paletteColorsV3.radicalRed[900],
      attention: paletteColorsV3.sunnyYellow[900],
      success: paletteColorsV3.tiffanyBlue[900],
      info: paletteColorsV3.blueGreen[900]
    },
    text: paletteColorsV3.grey[800]
  },
  scroll: {
    light: {
      track: paletteColorsV3.white,
      handle: {
        default: paletteColorsV3.secondary[300],
        hover: paletteColorsV3.secondary[500]
      }
    },
    dark: {
      track: paletteColorsV3.grey[600],
      handle: {
        default: paletteColorsV3.grey[600],
        hover: paletteColorsV3.grey[600]
      }
    }
  },
  segment: {
    solid: {
      selected: {
        content: {
          default: paletteColorsV3.white,
          hover: paletteColorsV3.white
        },
        bg: {
          disabled: paletteColorsV3.grey[400]
        }
      },
      content: {
        disabled: paletteColorsV3.grey[500]
      }
    },
    primary: {
      solid: {
        selected: {
          bg: {
            default: paletteColorsV3.primary[900],
            hover: paletteColorsV3.primary[800]
          }
        },
        content: {
          disabled: paletteColorsV3.grey[500]
        }
      },
      transparent: {
        selected: {
          border: {
            default: paletteColorsV3.primary[900],
            hover: paletteColorsV3.primary[800]
          },
          content: {
            default: paletteColorsV3.primary[900],
            hover: paletteColorsV3.primary[800]
          }
        }
      }
    },
    secondary: {
      solid: {
        selected: {
          bg: {
            default: paletteColorsV3.primary[900],
            hover: paletteColorsV3.primary[800]
          }
        }
      },
      transparent: {
        selected: {
          border: {
            default: paletteColorsV3.secondary[900],
            hover: paletteColorsV3.secondary[800]
          },
          content: {
            default: paletteColorsV3.secondary[900],
            hover: paletteColorsV3.secondary[800]
          }
        }
      }
    },
    bg: {
      default: paletteColorsV3.white,
      hover: paletteColorsV3.white
    },
    transparent: {
      selected: {
        border: {
          disabled: paletteColorsV3.grey[400]
        },
        bg: {
          disabled: paletteColorsV3.grey[200]
        },
        content: {
          disabled: paletteColorsV3.grey[500]
        }
      }
    },
    unselected: {
      content: {
        default: paletteColorsV3.grey[800],
        hover: paletteColorsV3.primary[800]
      },
      border: {
        default: paletteColorsV3.grey[400],
        hover: paletteColorsV3.grey[500],
        disabled: paletteColorsV3.grey[400]
      },
      bg: {
        disabled: paletteColorsV3.grey[200]
      }
    }
  },
  signal: {
    primary: {
      bg: paletteColorsV3.white,
      text: paletteColorsV3.grey[800],
      border: {
        error: paletteColorsV3.radicalRed[900],
        attention: paletteColorsV3.sunnyYellow[900],
        success: paletteColorsV3.tiffanyBlue[900],
        info: paletteColorsV3.blueGreen[900]
      },
      progress: {
        error: paletteColorsV3.radicalRed[900],
        attention: paletteColorsV3.sunnyYellow[900],
        success: paletteColorsV3.tiffanyBlue[900],
        info: paletteColorsV3.blueGreen[900]
      },
      icon: {
        error: paletteColorsV3.radicalRed[900],
        attention: paletteColorsV3.sunnyYellow[900],
        success: paletteColorsV3.tiffanyBlue[900],
        info: paletteColorsV3.blueGreen[900]
      },
      footer: {
        error: paletteColorsV3.radicalRed[900],
        attention: paletteColorsV3.sunnyYellow[900],
        success: paletteColorsV3.tiffanyBlue[900],
        info: paletteColorsV3.blueGreen[900]
      }
    },
    secondary: {
      content: paletteColorsV3.white,
      border: paletteColorsV3.white,
      bg: {
        error: paletteColorsV3.radicalRed[900],
        attention: paletteColorsV3.sunnyYellow[900],
        success: paletteColorsV3.tiffanyBlue[900],
        info: paletteColorsV3.blueGreen[900]
      },
      progress: {
        error: paletteColorsV3.radicalRed[600],
        attention: paletteColorsV3.sunnyYellow[600],
        success: paletteColorsV3.tiffanyBlue[600],
        info: paletteColorsV3.blueGreen[600]
      },
      track: {
        error: paletteColorsV3.radicalRed[300],
        attention: paletteColorsV3.sunnyYellow[300],
        success: paletteColorsV3.tiffanyBlue[300],
        info: paletteColorsV3.blueGreen[300]
      }
    }
  },
  tooltip: {
    content: paletteColorsV3.white,
    bg: paletteColorsV3.grey[800]
  },
  hint: {
    normal: {
      content: paletteColorsV3.white,
      bg: paletteColorsV3.grey[800]
    },
    critical: {
      soft: {
        content: paletteColorsV3.grey[800],
        bg: paletteColorsV3.radicalRed[300]
      },
      content: paletteColorsV3.white,
      bg: paletteColorsV3.radicalRed[900]
    },
    sidebar: {
      content: paletteColorsV3.white,
      bg: paletteColorsV3.secondary[900]
    }
  },
  picker: {
    primary: {
      body: paletteColorsV3.grey[800],
      header: paletteColorsV3.grey[900],
      border: paletteColorsV3.grey[700],
      content: paletteColorsV3.white,
      segment: {
        normal: {
          bg: {
            default: paletteColorsV3.grey[800],
            hover: paletteColorsV3.grey[900]
          }
        },
        selected: {
          bg: {
            default: paletteColorsV3.secondary[900],
            hover: paletteColorsV3.secondary[800]
          }
        },
        interim: {
          bg: {
            default: paletteColorsV3.secondary[1e3],
            hover: paletteColorsV3.grey[700]
          }
        },
        current: {
          bg: {
            default: paletteColorsV3.grey[700],
            hover: paletteColorsV3.grey[600]
          }
        }
      }
    },
    secondary: {
      header: paletteColorsV3.secondary[400],
      border: paletteColorsV3.secondary[400],
      content: {
        default: paletteColorsV3.grey[700],
        disabled: paletteColorsV3.grey[400]
      },
      segment: {
        normal: {
          bg: {
            default: paletteColorsV3.white,
            hover: paletteColorsV3.secondary[200]
          }
        },
        selected: {
          bg: {
            default: paletteColorsV3.secondary[500],
            hover: paletteColorsV3.secondary[600]
          }
        },
        interim: {
          bg: {
            default: paletteColorsV3.secondary[300],
            hover: paletteColorsV3.grey[500]
          }
        },
        current: {
          bg: {
            default: paletteColorsV3.grey[200],
            hover: paletteColorsV3.secondary[300]
          }
        }
      }
    }
  },
  schedule: {
    created: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.blueGreen[200],
        active: paletteColorsV3.blueGreen[200]
      },
      border: {
        default: paletteColorsV3.blueGreen[300],
        hover: paletteColorsV3.blueGreen[300],
        active: paletteColorsV3.blueGreen[900]
      },
      indicator: paletteColorsV3.blueGreen[900]
    },
    confirmed: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.radicalRed[200],
        active: paletteColorsV3.radicalRed[200]
      },
      border: {
        default: paletteColorsV3.radicalRed[300],
        hover: paletteColorsV3.radicalRed[300],
        active: paletteColorsV3.radicalRed[900]
      },
      indicator: paletteColorsV3.radicalRed[900]
    },
    unconfirmed: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.gamboge[200],
        active: paletteColorsV3.gamboge[200]
      },
      border: {
        default: paletteColorsV3.gamboge[300],
        hover: paletteColorsV3.gamboge[300],
        active: paletteColorsV3.gamboge[900]
      },
      indicator: paletteColorsV3.gamboge[900]
    },
    completed: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.tiffanyBlue[200],
        active: paletteColorsV3.tiffanyBlue[200]
      },
      border: {
        default: paletteColorsV3.tiffanyBlue[300],
        hover: paletteColorsV3.tiffanyBlue[300],
        active: paletteColorsV3.tiffanyBlue[900]
      },
      indicator: paletteColorsV3.tiffanyBlue[900]
    },
    bg: {
      disabled: paletteColorsV3.white
    },
    border: {
      disabled: paletteColorsV3.grey[300]
    },
    indicator: {
      disabled: paletteColorsV3.grey[400]
    }
  },
  event: {
    content: {
      default: paletteColorsV3.grey[800],
      hover: paletteColorsV3.grey[800],
      active: paletteColorsV3.grey[800]
    },
    work: {
      bg: {
        default: paletteColorsV3.secondary[200],
        hover: paletteColorsV3.secondary[300],
        active: paletteColorsV3.secondary[300]
      },
      border: {
        default: paletteColorsV3.secondary[500],
        hover: paletteColorsV3.secondary[700],
        active: paletteColorsV3.secondary[900]
      }
    },
    break: {
      bg: {
        default: paletteColorsV3.primary[300],
        hover: paletteColorsV3.primary[300],
        active: paletteColorsV3.primary[300]
      },
      border: {
        default: paletteColorsV3.primary[500],
        hover: paletteColorsV3.primary[700],
        active: paletteColorsV3.primary[900]
      }
    }
  },
  sidepanel: {
    content: paletteColorsV3.secondary[900],
    primary: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.secondary[200],
        pressed: paletteColorsV3.secondary[300]
      }
    },
    secondary: {
      bg: {
        default: paletteColorsV3.secondary[300],
        hover: paletteColorsV3.secondary[400],
        pressed: paletteColorsV3.secondary[500]
      }
    }
  },
  accordion: {
    solid: {
      bg: {
        default: paletteColorsV3.white,
        active: paletteColorsV3.secondary[200]
      },
      border: paletteColorsV3.secondary[300],
      icon: {
        default: paletteColorsV3.grey[400],
        active: paletteColorsV3.secondary[500]
      },
      text: paletteColorsV3.grey[800]
    },
    transparent: {
      default: paletteColorsV3.grey[700],
      active: paletteColorsV3.grey[500]
    }
  },
  card: {
    primary: {
      bg: {
        default: paletteColorsV3.secondary[200],
        hover: paletteColorsV3.secondary[300],
        active: paletteColorsV3.secondary[500],
        disabled: paletteColorsV3.grey[300]
      },
      border: {
        default: paletteColorsV3.secondary[500],
        hover: paletteColorsV3.secondary[500],
        active: paletteColorsV3.secondary[700],
        disabled: paletteColorsV3.grey[400]
      }
    },
    secondary: {
      bg: {
        default: paletteColorsV3.white,
        hover: paletteColorsV3.secondary[200],
        active: paletteColorsV3.secondary[300],
        disabled: paletteColorsV3.grey[300]
      },
      border: {
        default: paletteColorsV3.grey[400],
        hover: paletteColorsV3.secondary[400],
        active: paletteColorsV3.secondary[500],
        disabled: paletteColorsV3.grey[400]
      }
    }
  },
  message: {
    border: paletteColorsV3.secondary[300],
    outgoing: {
      bg: paletteColorsV3.secondary[200],
      content: paletteColorsV3.grey[800]
    },
    incoming: {
      bg: {
        default: paletteColorsV3.white,
        read: paletteColorsV3.white,
        hover: paletteColorsV3.grey[100],
        active: paletteColorsV3.secondary[200]
      },
      content: {
        default: paletteColorsV3.grey[800],
        read: paletteColorsV3.grey[700],
        hover: paletteColorsV3.grey[700],
        active: paletteColorsV3.grey[700]
      }
    },
    indicator: paletteColorsV3.secondary[900]
  },
  dialog: {
    primary: {
      content: paletteColorsV3.white,
      border: paletteColorsV3.grey[700],
      bg: {
        body: paletteColorsV3.grey[800],
        header: paletteColorsV3.grey[700]
      }
    },
    secondary: {
      content: paletteColorsV3.grey[800],
      border: paletteColorsV3.grey[400],
      bg: {
        body: paletteColorsV3.grey[100],
        header: paletteColorsV3.grey[200]
      }
    }
  },
  taskmessage: {
    bg: {
      error: paletteColorsV3.radicalRed[200],
      attention: paletteColorsV3.sunnyYellow[200],
      success: paletteColorsV3.tiffanyBlue[200]
    },
    content: paletteColorsV3.grey[800]
  }
};
export {
  colorTokens
};
//# sourceMappingURL=colorTokens.js.map
